import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { saveSurvey } from './dynamodb';

function IssueReport() {
  const [formData, setFormData] = useState({
    issueDate: '',
    issueType: '',
    description: ''
  });
  const [captchaValue, setCaptchaValue] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('success');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaValue) {
      setModalType('error');
      setShowModal(true);
      return;
    }
    
    setIsSubmitting(true);
    try {
      await saveSurvey({ ...formData, type: 'issue_report' });
      setModalType('success');
      setShowModal(true);
      setFormData({ issueDate: '', issueType: '', description: '' });
      setCaptchaValue(null);
    } catch (error) {
      setModalType('error');
      setShowModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="survey-container">
      <div className="survey-pattern"></div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 col-12">
            <div className="modern-form p-5 fade-in">
              <div className="text-center">
                <div className="survey-icon mx-auto" style={{background: '#dc2626'}}>🚨</div>
                <h1 className="survey-title">Report FirstPort Issues</h1>
                <p className="survey-subtitle">Help us document problems with FirstPort's service</p>
              </div>
              <div className="alert-custom mb-4">
                <strong>Report Problems:</strong> Your feedback helps build a comprehensive record of service issues.
              </div>
              
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label">Date Issue Occurred *</label>
          <input 
            type="date" 
            className="form-control" 
            value={formData.issueDate}
            onChange={(e) => setFormData({...formData, issueDate: e.target.value})}
            required 
          />
        </div>

                <div className="mb-4">
                  <label className="form-label">Type of Issue</label>
          <select 
            className="form-select" 
            value={formData.issueType}
            onChange={(e) => setFormData({...formData, issueType: e.target.value})}
          >
            <option value="">Select issue type...</option>
            <option value="maintenance">Maintenance Delays</option>
            <option value="charges">Service Charge Issues</option>
            <option value="communication">Poor Communication</option>
            <option value="staff">Staff Problems</option>
            <option value="other">Other</option>
          </select>
        </div>



                <div className="mb-4">
                  <label className="form-label">Description of Issue *</label>
          <textarea 
            className="form-control" 
            rows="5" 
            placeholder="Please provide detailed description of the issue you experienced with FirstPort..."
            value={formData.description}
            onChange={(e) => setFormData({...formData, description: e.target.value})}
            required
          ></textarea>
        </div>

                <div className="mb-4 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6Ldifl0pAAAAADZCvzJSAm-wBdsmx0flhew4zXhT"
                    onChange={setCaptchaValue}
                    size="compact"
                  />
                </div>
                <div className="text-center mt-4">
                  <button type="submit" className="btn btn-danger-survey" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit Issue Report'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      {showModal && (
        <div className="success-modal" onClick={() => setShowModal(false)}>
          <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className={`success-icon ${modalType === 'error' ? 'error-icon' : ''}`}>
              {modalType === 'success' ? '✓' : '⚠'}
            </div>
            <h3 className="mb-3">
              {modalType === 'success' ? 'Report Submitted!' : 'Submission Error'}
            </h3>
            <p className="text-muted mb-4">
              {modalType === 'success' 
                ? 'Thank you for reporting this issue. Your report has been recorded.' 
                : captchaValue ? 'There was an error submitting your report. Please try again.' : 'Please complete the CAPTCHA verification.'}
            </p>
            <button className="btn btn-danger-survey" onClick={() => setShowModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default IssueReport;